module.exports = __webpack_public_path__ + "static/media/clap.44b180f5.mp3";